import axiosAdmin from "../../api/axiosAdmin";
import { useEffect, useState } from "react";

const StatCard = ({ label, value }) => (
  <div className="bg-white shadow-md rounded-xl p-4 text-center">
    <div className="text-sm text-gray-500">{label}</div>
    <div className="text-2xl font-bold">{value}</div>
  </div>
);

const formatLabel = (key) => {
  switch (key) {
    case "requests":
      return "Total Requests";
    case "djs":
      return "Total DJs";
    case "onlineDjs":
      return "Online DJs";
    case "paidRequests":
      return "Paid Requests";
    default:
      return key;
  }
};

const Dashboard = () => {
  const [stats, setStats] = useState({
    requests: 0,
    djs: 0,
    onlineDjs: 0,
    paidRequests: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [requestsRes, djsRes, onlineDjsRes, paidRequests] =
          await Promise.all([
            axiosAdmin.get("/request/all/count"),
            axiosAdmin.get("/dj/all/count"),
            axiosAdmin.get("/dj/all/online/count"),
            axiosAdmin.get("/request/paid/count"),
          ]);

        setStats({
          requests: requestsRes.data,
          djs: djsRes.data,
          onlineDjs: onlineDjsRes.data,
          paidRequests: paidRequests.data,
        });
      } catch (error) {
        console.error("Error fetching dashboard stats:", error);
      }
    };

    fetchStats();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        {Object.entries(stats).map(([key, value]) => (
          <StatCard key={key} label={formatLabel(key)} value={value} />
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
